module.exports = __webpack_public_path__ + "img/notify.fb2b34f3.png";